export const SlideData = [
    {
      id: 1,
      price: "200000 MMK",
      cate: "Wicked Lady White Zinfandel Rose Wine 75cl",
      img: "https://secretbottleshop.co.uk/cdn/shop/products/aa9044f4-721b-4a9e-b0fa-91493230cf24_531x531.jpg?v=1681978873",
      label:"Wicked Lady"
    },
    {
      id: 2,
      price: "230000 MMK",
      cate: "Jack And Gina Zinfandel Rose Wine 75cl",
      img: "https://secretbottleshop.co.uk/cdn/shop/products/b838aec5-27b7-464b-b0d4-43a6b72509d3_378x378.jpg?v=1665157655",
      label:"Jack And Gina"
    },
    {
      id: 3,
      price: "260000 MMK",
      cate: "Selladore En Provence Rose Wine 2022 75cl",
      img: "https://secretbottleshop.co.uk/cdn/shop/products/9e8ed706-e2cf-4580-b454-ed44052ed92c_531x531.jpg?v=1678464571",
      label:"William Chase"
    },
    {
      id: 4,
      price: "300000 MMK",
      cate: "Chateau d'Esclans Whispering Angel Rose Wine 2022 75cl",
      img: "  https://secretbottleshop.co.uk/cdn/shop/products/4c70485f-27a0-4f3c-b723-9e10ad1c2e0d_531x531.jpg?v=1678798229",
      label:"Chateau d'Esclans"
    },
    {
      id: 5,
      price: "something",
      cate: "recom",
      img:"https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/commerce%2Fwhiskyhouse%2Fitems%2F-NYxTxbMew2iGaQCmrZF?alt=media&token=7d889779-1bf4-4789-81ec-827b302f9cce" ,
    },
  ];